import React from "react";
import "./App.css";
import SLPPHPConverter from "./converters/SlpPhp";
import CryptoPicker from "./components/CryptoPicker";
import CryptoDetails from "./components/CryptoDetails";
import { BrowserRouter, Route, Switch } from "react-router-dom";

const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        {/* <Route path={"/:id"}>
          <CryptoDetails />
        </Route> */}
        <Route>
          {/* <CryptoPicker /> */}
          <CryptoDetails />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default App;
